import { NextSeo } from 'next-seo'
import VerifiedDeploy from 'views/VerifiedDeploy'

/** CADINU Verified Deploy: upload a Solidity artifact, review, sign in the wallet, verify the deployed runtime. Strict CSP: see views/VerifiedDeploy/csp.mjs. */
const VerifiedDeployPage = () => <VerifiedDeploy />
VerifiedDeployPage.Meta = () => (
  <NextSeo
    title="CADINU Verified Deploy"
    description="Deploy a Solidity contract from its artifact with your own wallet, then verify the deployed bytecode against the artifact. No keys, no third-party scripts."
  />
)
// every EVM network the wallet is on: the page never asks to switch
VerifiedDeployPage.chains = []
export default VerifiedDeployPage
